import React, { useState } from 'react';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import ContentCopyIcon from '@mui/icons-material/ContentCopyRounded';
import CheckIcon from '@mui/icons-material/CheckRounded';

import { copyToClipboard } from 'src/components/copy-text-button/utils';

type Props = {
  text?: string;
  className?: string;
  'data-testid'?: string;
}

const CopyTextButton: React.FC<Props> = ({ text, className, 'data-testid': dataTestId }) => {
    const [isCopied, setCopied] = useState(false);

    if (!text) {
        return null;
    }

    const handleCopy = async () => {
        const isSuccess = await copyToClipboard(text);
        if (isSuccess) {
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        }
    };

    return (
        <IconButton onClick={handleCopy} size="small" disabled={isCopied} className={className} data-testid={dataTestId}>
            {!isCopied && <ContentCopyIcon fontSize="small" />}
            {isCopied && (
                <Tooltip arrow title="Copied" open>
                    <CheckIcon color="success" fontSize="small" />
                </Tooltip>
            )}
        </IconButton>
    );
};

export default CopyTextButton;